import React from 'react'
import { Redirect } from 'react-router-dom'
import {
  Input,
  Container,
  Segment,
  Table,
  Grid,
  Loader,
  Dropdown,
  Button
} from 'semantic-ui-react'


import titleCase from 'title-case'

import './Subjects.css'
import PaginationTable from '../../components/PaginationTable/PaginationTable'
import SubjectsAdd from './SubjectsAdd'
import SubjectsView from './SubjectsView'
import SubjectsEdit from './SubjectsEdit'
import SubjectsDelete from './SubjectsDelete'
import SubjectsReadCSV from './SubjectsReadCSV'

const changeCase = {
    titleCase: titleCase
}

const SubjectsPV = (props) => {
  if (props.auth) {
    if (props.userType === 'admin' || props.userType === 'principal' || props.userType === 'registrar') {
    const { activePage, itemPerPage, column, direction, data, searchKey, fields, loaded, schoolYearId } = props;
    if (!props.currentSchoolYear) return null;
    let currentData = data.filter(props.isSearched(searchKey));
    const indexOfLast = activePage * itemPerPage;
    const indexOfFirst = indexOfLast - itemPerPage;
    const rowLength = currentData.length;
    currentData = currentData.slice(indexOfFirst, indexOfLast);
    const totalPages = Math.ceil(rowLength / itemPerPage);

    const subjectTable = currentData.map((subject, key )=> {
      return (
        <Table.Row key={key} className='subjects-table-row'>
          <Table.Cell>{subject.name}</Table.Cell>
          <Table.Cell>{subject.code}</Table.Cell>
          <Table.Cell>{subject.subjectCategory}</Table.Cell>
          <Table.Cell collapsing>
            <SubjectsView
              subject={subject}
            />
            <SubjectsEdit
              subject={subject}
              handleUpdate={props.handleUpdate}
            />

            <SubjectsDelete
              subjectId={subject.subjectId}
              subjectName={subject.name}
              handleDelete={props.handleDelete}
            />
          </Table.Cell>
        </Table.Row>
      );
    });

    let headers = fields.map((field,index) => {
      return (
        <Table.HeaderCell
          key={index}
          sorted={column === field ? direction : null}
          onClick={() => props.handleSort(field)}
          textAlign='center'
        >
          {changeCase.titleCase(field)}
        </Table.HeaderCell>
      )
    });

    let optionsSchoolYears;
    if (props.schoolYears) {
      optionsSchoolYears = props.schoolYears.map((schoolYear,index) => {
        return (
            { key: schoolYear.schoolYearId, value: schoolYear.schoolYearId, text: schoolYear.name }
        )
      })
    }

    return (
      <div>
        <Container>
          <Segment>
            <Grid>
              <Grid.Column floated='left' width={8}>
                <Grid.Column width={4}>
                  <Input
                    icon='search'
                    value={searchKey}
                    onChange={props.onSearchChange}
                    placeholder='Search Subjects'
                  />
                </Grid.Column>
              </Grid.Column>
              <Grid.Column width={8}>
                <Button.Group floated='right'>
                  <SubjectsReadCSV
                    handleFileChange={props.handleFileChange}
                    handleDataSave={props.handleDataSave}
                  />
                  <Button.Or />
                  <SubjectsAdd
                    schoolYearId={schoolYearId}
                    handleSubmit={props.handleSubmit}
                  />
                </Button.Group>


              </Grid.Column>
            </Grid>
            <Grid centered columns={5}>
              <Grid.Column>
                <Dropdown
                  selection
                  options={optionsSchoolYears}
                  onChange={props.handleChange}
                  value={schoolYearId}
                />
              </Grid.Column>
            </Grid>
            {
              loaded ?
              <div className='table-subjects'>
                {
                  data.length > 0 ?
                  <Table celled selectable sortable striped size='small'>
                    <Table.Header>
                      <Table.Row>
                        {headers}
                      </Table.Row>
                    </Table.Header>

                    <Table.Body>{subjectTable}</Table.Body>
                      {
                        data.length > itemPerPage ?
                        <PaginationTable
                          onPageChange={props.handlePaginationChange}
                          totalPages={totalPages}
                          activePage={activePage}
                          fields={fields}
                        >

                        </PaginationTable>
                        :
                        null
                      }
                  </Table>
                  :
                  <Segment>No subject records found.</Segment>
                }
              </div>
              :
              <Loader active inline='centered' />
            }

          </Segment>
        </Container>
      </div>
    )
  } else {
    return <Segment>You are not authorized to be in this page.</Segment>
  }
  } else {
    return <Redirect to='/' />
  }

}

export default SubjectsPV;
